import React from 'react'
import styles from './slow-loading.module.scss'
import { Loader } from '#/shared'
import { CommonButton } from '#/shared/ui/button'
import { signOut } from 'next-auth/react'

interface SlowLoadingProps { }

export const SlowLoading = ({ }: SlowLoadingProps) => {
	return (
		<div className={styles.loading__box}>
			<Loader className={styles.loading__loader} size={50} />
			<p>Долгая загрузка</p>
			<span>Предлагаем перезайти</span>
			<CommonButton onClick={() => signOut()} variant='primary'>
				Выйти
			</CommonButton>
		</div>
	)
}
